import React from "react";

const AboutUs = () => {
  return (
    <div className="terms-and-condition container">
      <h1>About Socius</h1>
      <div className="mt-3 mb-5">
        <h4 className="mb-4">The smarter way to manage the people who matter.</h4>
        <p>
          <b>Socius</b> brings your relationships into focus by combining rich
          contact profiles, notes, conversations, call insights, reminders, and
          calendar events into one seamless experience. Instead of searching through
          scattered apps or relying on memory, you get the full context of every
          relationship exactly when you need it.
        </p>
        <br />
        <p>
          Use <b>Socius</b> for personal relationships, professional networking,
          client follow-ups, stakeholder management, event planning, or small-team
          collaboration — all with privacy-first controls designed to keep your data
          in your hands.
        </p>
        <br />
      </div>
    </div>
  );
};

export default AboutUs;
